import { DefaultLayout } from '../../layouts'
import { CallToActionSection } from './sections/CallToAction'
import { FeaturesSection } from './sections/Features'
import { HeroSection } from './sections/Hero'
import { IntegrationsSection } from './sections/Integrations'
import { UsagesSection } from './sections/Usages'

export const HomepageScreen = (): JSX.Element => {
  return (
    <DefaultLayout withMargins={false}>
      <HeroSection />
      <IntegrationsSection />
      <UsagesSection />
      <FeaturesSection />
      <CallToActionSection />
    </DefaultLayout>
  )
}

export default HomepageScreen
